/**
 * File list creator for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
 */

'use strict';

import {
    archiveFilesPrompt,
    createElemWithClasses,
    deleteFilesPrompt,
    freeTier,
    getItem,
    groupArrayOfObjects,
    mfetch,
    passwordPrompt,
    pinPrompt,
    resharePrompt,
    showFlash,
    showFreeTierDepletedPrompt,
    showPasswordErrorPrompt,
    unverifiedDownloadPrompt,
    updateFileCounters
} from './utils'
import {
    decryptMessage,
    downloadMultipleFiles,
    handleTransferRenaming,
    mainDecryptAllFilenames,
    mainDecryptFilename,
    mainDownload,
    mainFileLink,
    mainFileLinkPlugin,
    showExternalDownloadMessage,
    updateTable
} from "./download";
import {getRsaAlgorithm, getSecretKey, getSymmetricAlgorithm, prepareFileSharing, UserData} from "./crypto";

import {FileData} from "./upload";


const _numberOfShownFiles = 3;
const _timezoneOptions = Intl.DateTimeFormat().resolvedOptions(); // get timezone

export async function reshareFunction(files: any[], key: CryptoKey, userData: UserData, publicKey: CryptoKey, senderId: string, receiverId: string, secret?: string | undefined) {

    const sharedFiles = await prepareFileSharing(files, secret!, userData, key, publicKey)

    // upload this secret again
    mfetch('/files/share', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({files: sharedFiles, sender_uid: senderId, receiver_uid: receiverId}),
    }).then((response) => {
        if (response.status === 200 && Object.keys(sharedFiles).length === 1) {
            // $table.bootstrapTable('uncheckAll');
            showFlash('File was shared successfully', 'info')
        } else if(response.status === 200) {
            showFlash('Files were shared successfully', 'info')
        } else {
            showFlash('File could not be shared', 'warning')
        }
    })
}


/**
 * Sort the transfer list with newest first
 *
 */
function sortGroups(data: any,
                    groupKey: string,
                    groupDir: number,
                    itemKey: string,
                    itemDir: number
                    ) {
    const grouped = groupArrayOfObjects(data, 'prefix');

    // let itemDir = itemDirection == 'asc' ? -1 : 1

    const groupedList = Object.keys(grouped).map(function(key: string) {
        return grouped[key].sort((a: any, b: any) => {  // sort within group
            if(a[itemKey] === b[itemKey]) {
            return 0
        }
        return a[itemKey] < b[itemKey] ? itemDir : -itemDir
        });
    });

    // let groupDir = groupDirection == 'asc' ? -1 : 1

    const sortedGroup = groupedList.sort((a: any, b: any) => {

        if(a[0][groupKey] === b[0][groupKey]) {
            return 0
        }
        return a[0][groupKey] < b[0][groupKey] ? groupDir : -groupDir
    })
    return sortedGroup
}


// function renderIcon() {
    //const { h } = require('preact')
    //
    // function iconImage () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" width="25" height="25" viewBox="0 0 25 25">
    //       <g fill="#686DE0" fillRule="evenodd">
    //         <path d="M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z" fillRule="nonzero" />
    //         <path d="M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z" fillRule="nonzero" />
    //         <circle cx="7.5" cy="9.5" r="1.5" />
    //       </g>
    //     </svg>
    //   )
    // }
    //
    // function iconAudio () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" className="uppy-c-icon" width="25" height="25" viewBox="0 0 25 25">
    //       <path d="M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z" fill="#049BCF" fillRule="nonzero" />
    //     </svg>
    //   )
    // }
    //
    // function iconVideo () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" className="uppy-c-icon" width="25" height="25" viewBox="0 0 25 25">
    //       <path d="M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z" fill="#19AF67" fillRule="nonzero" />
    //     </svg>
    //   )
    // }
    //
    // function iconPDF () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" className="uppy-c-icon" width="25" height="25" viewBox="0 0 25 25">
    //       <path d="M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z" fill="#E2514A" fillRule="nonzero" />
    //     </svg>
    //   )
    // }
    //
    // function iconArchive () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" width="25" height="25" viewBox="0 0 25 25">
    //       <path d="M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z" fill="#00C469" fillRule="nonzero" />
    //     </svg>
    //   )
    // }
    //
    // function iconFile () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" className="uppy-c-icon" width="25" height="25" viewBox="0 0 25 25">
    //       <g fill="#A7AFB7" fillRule="nonzero">
    //         <path d="M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z" />
    //         <path d="M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z" />
    //       </g>
    //     </svg>
    //   )
    // }
    //
    // function iconText () {
    //   return (
    //     <svg aria-hidden="true" focusable="false" className="uppy-c-icon" width="25" height="25" viewBox="0 0 25 25">
    //       <path d="M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z" fill="#5A5E69" fillRule="nonzero" />
    //     </svg>
    //   )
    // }
    //
    // module.exports = function getIconByMime (fileType) {
    //   const defaultChoice = {
    //     color: '#838999',
    //     icon: iconFile(),
    //   }
    //
    //   if (!fileType) return defaultChoice
    //
    //   const fileTypeGeneral = fileType.split('/')[0]
    //   const fileTypeSpecific = fileType.split('/')[1]
    //
    //   // Text
    //   if (fileTypeGeneral === 'text') {
    //     return {
    //       color: '#5a5e69',
    //       icon: iconText(),
    //     }
    //   }
    //
    //   // Image
    //   if (fileTypeGeneral === 'image') {
    //     return {
    //       color: '#686de0',
    //       icon: iconImage(),
    //     }
    //   }
    //
    //   // Audio
    //   if (fileTypeGeneral === 'audio') {
    //     return {
    //       color: '#068dbb',
    //       icon: iconAudio(),
    //     }
    //   }
    //
    //   // Video
    //   if (fileTypeGeneral === 'video') {
    //     return {
    //       color: '#19af67',
    //       icon: iconVideo(),
    //     }
    //   }
    //
    //   // PDF
    //   if (fileTypeGeneral === 'application' && fileTypeSpecific === 'pdf') {
    //     return {
    //       color: '#e25149',
    //       icon: iconPDF(),
    //     }
    //   }
    //
    //   // Archive
    //   const archiveTypes = ['zip', 'x-7z-compressed', 'x-rar-compressed', 'x-tar', 'x-gzip', 'x-apple-diskimage']
    //   if (fileTypeGeneral === 'application' && archiveTypes.indexOf(fileTypeSpecific) !== -1) {
    //     return {
    //       color: '#00C469',
    //       icon: iconArchive(),
    //     }
    //   }
    //
    //   return defaultChoice
    // }
    // const types = {
    //     pdf: `<div class="uppy-Dashboard-Item-previewInnerWrap" style="background-color: white;"><div class="uppy-Dashboard-Item-previewIconWrap"><span class="uppy-Dashboard-Item-previewIcon" style="color: rgb(226, 81, 73);"><svg aria-hidden="true" focusable="false" class="uppy-c-icon" width="25" height="25" viewBox="0 0 25 25"><path d="M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z" fill="#E2514A" fill-rule="nonzero"></path></svg></span><svg aria-hidden="true" focusable="false" class="uppy-Dashboard-Item-previewIconBg" width="58" height="76" viewBox="0 0 58 76"><rect fill="#FFF" width="58" height="76" rx="3" fill-rule="evenodd"></rect></svg></div></div>`
    // }
//     const other = `<div class="uppy-Dashboard-Item-previewInnerWrap" style="background-color: white;">
// <div class="uppy-Dashboard-Item-previewIconWrap">
// <span class="uppy-Dashboard-Item-previewIcon" style="color: rgb(131, 137, 153);">
// <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-lock2" viewBox="0 0 16 16">
//   <path d="M10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0zM7 7v1h2V7a1 1 0 0 0-2 0z"/>
//   <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
// </svg>
// </div></div>`
//
//
//
//     return `
//     <div class="uppy-Dashboard-Item-preview">
//         <div class="uppy-Dashboard-Item-previewInnerWrap" style="background-color: rgb(226, 81, 73);">
//             ${other}
//
//         </div>
//     </div>
// `
// }

function renderDefaultIcon(r?: number, g?: number, b?: number): string {
    if(!r) {
        r = 200
    }
    if(!g) {
        g = 200
    }
    if(!b) {
        b = 200
    }
    return `
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="rgb(${r}, ${g}, ${b})"
     class="bi bi-file-earmark-lock2"
     viewBox="0 0 16 16">
<!--     <g -->
<!--     transform="translate(-5 -5)">-->
<!--    <path d="M10 7v1.076c.54.166 1 .597 1 1.224v2.4c0 .816-.781 1.3-1.5 1.3h-3c-.719 0-1.5-.484-1.5-1.3V9.3c0-.627.46-1.058 1-1.224V7a2 2 0 1 1 4 0zM7 7v1h2V7a1 1 0 0 0-2 0z"></path>-->
<!--    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"></path>-->
<!--</g>-->
<!--<g -->
<!--     transform="translate(5 5)">-->
  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
  <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
<!--  </g>-->

</svg>
`
}
function renderUnread(file: FileData, tableMode: string) {

    if(tableMode === 'inbox' && file.download_count === 0) {
        return '<span class="unread-dot"></span>'
    }
    return ''

}

function fileEntry(rowIndex: number, index: number, file: FileData, mode: string, isPlugin: boolean, tableMode: string): string {
    return `
<div class="list-item-title d-flex"><input class="list-item-checkbox" type="checkbox" ${isPlugin ? 'disabled' : ''} id="list-item-checkbox-${rowIndex}-${index}">
    <label class="list-item-name" for="list-item-checkbox-${rowIndex}-${index}">
        <div class="uppy-Dashboard-Item" role="listitem">
            <div class="uppy-Dashboard-Item-preview download-button">
                <div class="uppy-Dashboard-Item-previewInnerWrap">                    
                    <div class="uppy-Dashboard-Item-previewInnerWrap" style="background-color: white;">
                        <div class="uppy-Dashboard-Item-previewIconWrap">
                        <span class="uppy-Dashboard-Item-previewIcon">
                            ${renderDefaultIcon()}
                        </span>
                        </div>
                    </div>                    
                </div>
            </div>

            <div class="uppy-Dashboard-Item-fileInfoAndButtons">
                <div class="uppy-Dashboard-Item-fileInfo" data-uppy-file-source="Dashboard">
                    <div class="uppy-Dashboard-Item-name">
                        ${renderUnread(file, tableMode)}
                        ${file.filename}
<!--                        <button class="download-button">Download</button>-->
                    </div>
                    <div class="uppy-Dashboard-Item-status">
                        <div class="uppy-Dashboard-Item-statusSize"><span class="text-capitalize">Size</span>: ${file.size}</div>
                        <br>
                        <div class="uppy-Dashboard-Item-statusSize">${(mode === 'external_download' ? "" : `<span class="text-capitalize">Downloads</span>: ${file.downloads}`)}</div>
                    </div>
                </div>
            </div>
        </div>
    </label>
</div>
`;
}

function renderFileEntry(file: FileData, rowIndex: number, index: number, mode: string, isPlugin: boolean, tableMode: string): HTMLLIElement {
    const listItem = createElemWithClasses('li', ['transfer-file-list-item']) as HTMLLIElement
    listItem.dataset.prefix = file.prefix;
    listItem.dataset.size = file.size.toString();
    listItem.dataset.file_id = file.file_id;
    listItem.dataset.real_size = file.real_size.toString();
    listItem.dataset.name = file.name;
    listItem.dataset.actions = file.actions;
    listItem.dataset.date = file.create_date.toString();
    listItem.dataset.encrypted_filename = file.encrypted_filename;
    listItem.dataset.encrypted_filepath = file.encrypted_filepath;
    listItem.dataset.encrypted_transfername = file.encrypted_transfername;
    listItem.dataset.encryptedkey = file.encryptedkey;
    listItem.dataset.user_verified = file.user_verified;
    listItem.dataset.verified = file.verified;
    listItem.dataset.password_hash = file.password_hash;
    listItem.innerHTML = fileEntry(rowIndex, index, file, mode, isPlugin, tableMode)

    if (index >= _numberOfShownFiles) {
        listItem.classList.add('d-none')
        listItem.classList.add('default-collapsed')
    }
    listItem.appendChild(createElemWithClasses('div', ['bottom-progress-bar', 'd-none']))
    return listItem;
}


function renderShareMenu(file: FileData, mode: string, isPlugin: boolean) {
    const receiver = document.getElementById('receiver-uid') as HTMLInputElement
    if (receiver && !receiver.value) { //anonymous user
        return ""
    }
    if (isPlugin) {

             return `<span class="transfer-dropdown-menu">
                        <a class="single-link-button-plugin"
                            data-prefix="${file.prefix}" 
                            data-name="${file.name}">
                            Insert into Mail
                        </a>
                    </span>`

    }
     function renderShareLink() {
         if (mode === 'external_download') {
             return ''
         }
         if (mode === 'drive') {
             return ''
         }
         return `<a class="dropdown-item single-link-button"                                                
                         data-prefix="${file.prefix}" 
                         data-name="${file.name}">
                         Get share link
                    </a>`
    }

    function renderAddToMyInbox() {
         if (mode === 'external_download') {
             return `<a class="dropdown-item reshare-button-self" href="#">Add to my inbox</a>`
         }
         return ''
    }

    function renderUnarchive() {
        if (mode === 'drive') {
            return `<a class="dropdown-item transfer-item-header-actions-unarchivelink">Share again</a>`
        }
        return ''
    }

    function renderShareWithCollaborator() {
         if (mode === 'drive') {
             return ''
         }
         const organization = document.getElementById('organization') as HTMLInputElement
         if(organization && organization.value) {
             return '<a class="dropdown-item reshare-button-other" href="#">Share with contact</a>'
         }
         return ''
    }

    return `
        <span class="transfer-dropdown-menu">
            <a class="dropdown-toggle" type="button" id="sharemenu-${file.prefix}" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img class="small-icon" src="/img/icons/outline/menu-vertical.svg">
                Share
            </a>
            <div class="dropdown-menu" aria-labelledby="sharemenu-${file.prefix}">
                ${renderShareLink()}
                ${renderUnarchive()}
                ${renderShareWithCollaborator()}           
                ${renderAddToMyInbox()}
            </div>
        </span>    
`
}

function renderFileMenu(file: FileData, mode: string, isPlugin: boolean) {

    if (isPlugin) {
        return ''
    }

    function renderArchiveLink() {
        if (mode === 'drive') {
            return ''
        } else {
            return `<a class="dropdown-item transfer-item-header-actions-archivelink">Archive</a>`
        }
    }


    return `
        <span class="transfer-dropdown-menu">
            <a class="dropdown-toggle filemenu-link" type="button" id="filemenu-${file.prefix}" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <img class="small-icon" src="/img/icons/outline/menu-vertical.svg">
                Files
            </a>
            <div class="dropdown-menu" aria-labelledby="filemenu-${file.prefix}">
                ${renderArchiveLink()}
                <a class="dropdown-item transfer-item-header-actions-deletelink">Delete</a>                
            </div>
        </span>`

}



function renderTransferHeader(files: Array<FileData>, mode: string, isPlugin: boolean): string {
    const file = files[0];
    function renderFrom() {
        if(mode !== 'outbox' && mode !== 'external_download') {
            return `<div class="transfer-item-header-from">From: ${file.from}</div>`
        }
        return ""
    }

    function renderMessage() {
        if (file.encrypted_message === "") {
            return ""
        } else {
            // return `<a class="message-button">Show message</a>`   //
            return `<a class=""><img class="message-button small-icon" src="/img/icons/outline/message-circle.svg"> <span class=" message-button hide-on-small-devices">Show message</span></a>`
        }
    }

    function renderPinLock() {

        if (file.password_hash.toString() === 'true') {
            return `data-lock`
        } else {
            return ""
        }
    }

    function renderDownloadAllButton() {

        if (isPlugin) {
            return ''
        }
        if (files.length <= 1) {
            return ''
        }
        return `<a class="transfer-item-header-actions-ziplink">Download all</a>`
    }

    function renderTransferActions() {
        if(mode === 'external_download') {
            return `
            <div class="transfer-item-header-actions">    
                ${renderShareMenu(file, mode, isPlugin)}                                        
                ${renderDownloadAllButton()}                

            </div>`
        }
        return `
            <div class="transfer-item-header-actions">    
                ${renderShareMenu(file, mode, isPlugin)}                
                ${renderFileMenu(file, mode, isPlugin)}        
                ${renderDownloadAllButton()}           
                <span class="transfer-item-header-message">${renderMessage()}</span>
            </div>`
    }

    function renderTransferDate() {
        let locale = 'en-GB';
        if (window.location.pathname.includes('/de/')) {
            locale = 'de-DE';
        }
        if (window.location.pathname.includes('/fr/')) {
            locale = 'fr-FR';
        }
        let date = new Date(file.create_date).toLocaleString(locale, {timeZone: _timezoneOptions.timeZone});
        return `Download created on ${date}`
    }

    function getExpiry(file: FileData) {
        if(file.expiry === 'Never') {
            return ''
        }
        return `<div class="transfer-item-header-expiry">Download available for ${file.expiry}</div>`;
    }

    return `
        <div class="transfer-item-header-title d-flex">
            <div class="transfer-item-header-title-inner ${renderPinLock()}" id="${file.prefix}">${file.encrypted_transfername || "Transfer"}</div>            
        </div>
        <div class="transfer-item-header-meta">
            ${renderFrom()}
            <div class="transfer-item-header-date">${renderTransferDate()}</div>
            ${getExpiry(file)}
        </div>
        ${renderTransferActions()}`
}

const createRow = (files: FileData[], rowIndex: number, mode: string, isPlugin: boolean, tableMode: string) => {

    const transferLi = createElemWithClasses('Li', ['transfer-item'])
    transferLi.dataset.prefix = files[0].prefix;
    transferLi.dataset.name = files[0].name;
    transferLi.dataset.encrypted_message = files[0].encrypted_message;
    transferLi.dataset.encrypted_transfername = files[0].encrypted_transfername;
    transferLi.dataset.encrypted_filename = files[0].encrypted_transfername;
    transferLi.dataset.encrypted_filepath = files[0].encrypted_filepath;
    transferLi.dataset.encryptedkey = files[0].encryptedkey;
    transferLi.dataset.user_verified = files[0].user_verified;
    transferLi.dataset.password_hash = files[0].password_hash;

    function isRecent(file: FileData) {
        const tz = new Date().getTimezoneOffset() * 60 * 1000;
        const age = (new Date().getTime() - file.create_date + tz)
        return age < 5 * 60 * 1000
    }
    const classList = ['transfer-item-header']
    if(isRecent(files[0])) {
        classList.push('recent')
    }

    const transferHeader = createElemWithClasses('Div', classList)
    transferHeader.innerHTML = renderTransferHeader(files, mode, isPlugin)

    const listContent = createElemWithClasses('ul', ['transfer-file-list'])
    // transferTitle.appendChild(transferCheckbox)
    transferLi.appendChild(transferHeader)
    transferLi.appendChild(listContent)

    if (files.length > _numberOfShownFiles) {
        const opener = transferLi.appendChild(createElemWithClasses('div', ['opener']))
        const button = opener.appendChild(createElemWithClasses('div', ['w-100', 'show-more-files-button']))
        button.innerHTML = `<img class="small-icon" src="/img/icons/outline/chevron-down-small-circle.svg"> Show ${files.length - _numberOfShownFiles} more files`
    }

    files.forEach((file, index) => {
        const listItem = renderFileEntry(file, rowIndex, index, mode, isPlugin, tableMode);
        listContent.appendChild(listItem)
    })
    return transferLi
}




// noinspection TypeScriptValidateTypes
const generateTable = (data: any,
                       groupKey: string,
                       groupDirection: number,
                       itemKey: string,
                       itemDirection: number,
                       db: IDBDatabase,
                       mode: string) => {
    const isPlugin = document.body.classList.contains('plugin')
    // console.log(groupKey, groupDirection, itemKey, itemDirection)
    const filelist = document.getElementById('filelist') as HTMLUListElement;

    // 1 s
    const sortedGroups = sortGroups(data, groupKey, groupDirection, itemKey, itemDirection)

    sortedGroups.forEach((files, index) => {
        filelist.appendChild(createRow(files, index, mode, isPlugin, mode))
    })

    const showMoreButtons = document.getElementsByClassName('show-more-files-button') as HTMLCollection
    for (let item of showMoreButtons) {

        item.addEventListener('click', (e) => {
            e.preventDefault();

            const parent = item.parentNode!.parentNode!
            const hiddenListItems = parent.querySelectorAll('.transfer-file-list-item.d-none');

            const showMoreButton = parent.querySelector('.show-more-files-button')!;
            if(hiddenListItems.length === 0) {
                const visibleListItems = parent.querySelectorAll('.transfer-file-list-item');
                visibleListItems.forEach((listItem, index) => {
                    if(index >= _numberOfShownFiles) {
                        listItem.classList.add('d-none')
                    }
                    showMoreButton.innerHTML = `<img class="small-icon" src="/img/icons/outline/chevron-down-small-circle.svg"> Show ${visibleListItems.length - _numberOfShownFiles} more files`
                })
            } else {
                hiddenListItems.forEach((elem) => elem.classList.remove('d-none'))
                showMoreButton.innerHTML = `<img class="small-icon" src="/img/icons/outline/chevron-up-small-circle.svg"> Collapse list`
            }
        })
    }

    const checkBoxes = document.getElementsByClassName('list-item-checkbox')as HTMLCollection
    for (let item of checkBoxes) {
        item.addEventListener('click', (e: any)=>{
            const fileCheckbox = e.target as HTMLInputElement;
            const transfer = fileCheckbox.closest('.transfer-item')!;
            const filesInTransfer = transfer.querySelectorAll('.transfer-file-list-item').length
            const filesSelected = transfer.querySelectorAll('.list-item-checkbox:checked').length
            const zipLink = transfer.querySelector('.transfer-item-header-actions-ziplink')
            const fileMenu = transfer.querySelector('.filemenu-link')

            if(filesInTransfer <= 1 || filesSelected === 0) {
                if(zipLink) {
                    zipLink.innerHTML = 'Download all';   // note: save innerHtml
                }
                if(fileMenu) {
                    fileMenu.innerHTML = `<img class="small-icon" src="/img/icons/outline/menu-vertical.svg"> Files`;   // note: save innerHtml
                }
            } else {
                if(zipLink) {
                    zipLink.innerHTML = 'Download selected';   // note: save innerHtml
                }
                if(fileMenu) {
                    fileMenu.innerHTML = `<img class="small-icon" src="/img/icons/outline/menu-vertical.svg"> Selected Files`;   // note: save innerHtml
                }
            }
        })
    }
    const downloadZipButtons = document.getElementsByClassName('transfer-item-header-actions-ziplink')as HTMLCollection
    for (let item of downloadZipButtons) {

        item.addEventListener('click', (e) => {
            e.preventDefault()
            const transfer = (e.target as HTMLElement).closest('li')!;
            let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
            if (selection.length === 0) {
                selection = transfer.querySelectorAll('.list-item-checkbox')
            }
            const files = [...selection].map(x => x.closest('li')!.dataset)

            // @ts-ignore
            downloadMultipleFiles(db, files)

        })
    }
    const copyLinkToPluginButtons = document.getElementsByClassName('single-link-button-plugin')as HTMLCollection
    for (let item of copyLinkToPluginButtons) {

        item.addEventListener('click', (e) => {
            e.preventDefault()

            const transfer = (e.target as HTMLElement).closest('li')!;
            mainFileLinkPlugin(db, transfer.dataset).then(() => {})
            // let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
            // if (selection.length === 0) {
            //     selection = transfer.querySelectorAll('.list-item-checkbox')
            // }
            // const files = [...selection].map(x => x.closest('li').dataset)
            //
            // downloadMultipleFiles(db, files)

        })
    }

    function processFiles(files: any[], url: string, method: string) {
        const f = files.map(x => x.file_id)
        mfetch(url, {
            method: method,
            body: JSON.stringify(f),
             headers: {
                'Content-Type': 'application/json'
             },
        })
            .then((response) => {
                // if(response.status === 400) {
                //     showArchiveStorageExceeded()
                //     return {}
                // }
                if (response.status === 200) {
                    return response.json()
                }
                return {}
            })

            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                updateTable()
            })
    }
    const archiveButtons = document.getElementsByClassName('transfer-item-header-actions-archivelink')as HTMLCollection
    for (let item of archiveButtons) {
        item.addEventListener('click', (e) => {
            e.preventDefault()
            const transfer = (e.target as HTMLElement).closest('li')!;
            let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
            if (selection.length === 0) {
                selection = transfer.querySelectorAll('.list-item-checkbox')
            }
            const files = [...selection].map(x => x.closest('li')!.dataset)

            archiveFilesPrompt(function (res) {
                if (res) {
                    processFiles(files, "/file/archive/", 'PUT')
                }
            })

        })
    }

    const shareLinkButtons = document.getElementsByClassName('single-link-button') as HTMLCollection
    for (let item of shareLinkButtons) {
        item.addEventListener('click', (e) => {
            let target = e.target as HTMLAnchorElement;
            const data = target.closest('li')!.dataset
            if (freeTier()) {
                mainFileLink(db, data, false).then(function () {});
            } else {
                showFreeTierDepletedPrompt()
            }
        })
    }

    if (document.location && document.location.pathname.indexOf('/external_download') >= 0) {
        const reshareButtons = document.getElementsByClassName('reshare-button-self') as HTMLCollection

        for(let item of reshareButtons) {
            item.addEventListener('click', async (e) => {
                e.preventDefault()
                const transfer = (e.target as HTMLElement).closest('li')!;
                let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
                if (selection.length === 0) {
                    selection = transfer.querySelectorAll('.list-item-checkbox')
                }
                const files = [...selection].map(x => x.closest('li')!.dataset)

                const senderId = document.getElementById("sender-uid") as HTMLInputElement
                const receiverId = document.getElementById("receiver-uid") as HTMLInputElement
                if (!senderId || !receiverId) {
                    return
                }

                const senderUid = senderId.value;
                const receiverUid = receiverId.value;

                // const userUid = senderId.value;
                const response = await mfetch('/key/' + receiverUid)
                const userData = await response.json()
                const publicKeyJwk = JSON.parse(userData.publicKey);
                const rsaAlgo = getRsaAlgorithm();

                const publicKey = await window.crypto.subtle.importKey('jwk',
                            publicKeyJwk,
                            rsaAlgo,
                            false,
                            publicKeyJwk.key_ops)
                let secret = document.location.toString();

                let hash = secret.split('#')[1];  // now we can continue as if we had a normal donwload link
                const split = hash.split('-');

                const iv = new Uint8Array(atob(split[0]).split(",").map(x => parseInt(x)));
                const keydata = JSON.parse(atob(split[1]));
                const algorithm = getSymmetricAlgorithm(iv);

                const symmetricKey = await window.crypto.subtle.importKey('jwk',
                    keydata,
                    algorithm,
                    false,
                    keydata.key_ops
                )
                await reshareFunction(files, symmetricKey, userData, publicKey, senderUid, receiverUid, secret)
            })
        }
    }

    const reshareButtons = document.getElementsByClassName('reshare-button-other') as HTMLCollection

    for(let item of reshareButtons) {
        item.addEventListener('click', async (e) => {
            e.preventDefault()
            const transfer = (e.target as HTMLElement).closest('li')!;
            let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
            if (selection.length === 0) {
                selection = transfer.querySelectorAll('.list-item-checkbox')
            }
            const files = [...selection].map(x => x.closest('li')!.dataset)



            async function callback(result: any) {
                if(result) {
                    // let fd = new FormData(document.getElementById('reshare-infos'))

                    const receiverUid = (document.getElementById('reshare-contact') as HTMLInputElement).value;
                    const senderUid = (document.getElementById('sender-uid') as HTMLInputElement).value;
                    const response = await mfetch('/key/' + receiverUid)
                    const userData = await response.json()
                    const publicKeyJwk = JSON.parse(userData.publicKey);
                    const rsaAlgo = getRsaAlgorithm();

                    const publicKey = await window.crypto.subtle.importKey('jwk',
                                publicKeyJwk,
                                rsaAlgo,
                                false,
                                publicKeyJwk.key_ops)

                    if (db) {
                        const oncomplete = async (ev: any) => {
                            let key = ev.target.result;
                            await reshareFunction(files, key, userData, publicKey, senderUid, receiverUid);
                        }
                        const onerror = () => {}

                        getItem(db, 'key', oncomplete, onerror)
                    } else {

                        async function callback(modalPassword: string) {
                            let key = await getSecretKey(modalPassword);
                            if (key) {
                                await reshareFunction(files, key, userData, publicKey, senderUid, receiverUid);
                            } else {
                                showPasswordErrorPrompt()
                            }
                        }
                        passwordPrompt(callback)
                    }
                }
            }
            //
            if (document.location && document.location.pathname.indexOf('/external_download') >= 0) {
                console.log('todo remove this function here')
            } else {
                // we can ask who in the org may get the file
                mfetch('/contacts/list/reshare')
                    .then(response => response.json())
                    .then(contacts => {
                        const options = contacts.users.map((x: any) => `<option value="${x.id}"'>${x.fullname} (${x.email})</option>`).join('\n')
                        const org = contacts.organization;
                        resharePrompt(callback, options, org)
                    })
            }
        })
    }



    const unarchiveButtons = document.getElementsByClassName('transfer-item-header-actions-unarchivelink')as HTMLCollection
    for (let item of unarchiveButtons) {

        item.addEventListener('click', (e) => {
            e.preventDefault()
            const transfer = (e.target as HTMLElement).closest('li')!;
            let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
            if (selection.length === 0) {
                selection = transfer.querySelectorAll('.list-item-checkbox')
            }
            const files = [...selection].map(x => x.closest('li')!.dataset)


            document.getElementById('unarchiveConfirmButton')!.addEventListener('click', function () {

                let daysToLive = '7';
                let downloadLimit = '100';

                let downloadLimitElement = document.querySelector('#unarchiveConfirmModal #expiry-download-input') as HTMLInputElement;
                if (downloadLimitElement) {
                    downloadLimit = downloadLimitElement.value
                }

                let daysToLiveElement = document.querySelector('#unarchiveConfirmModal #expiry-days-input') as HTMLInputElement;
                if (daysToLiveElement) {
                    daysToLive = daysToLiveElement.value
                }
                if(!downloadLimit) {
                    downloadLimit = '0'
                }

                processFiles(files, "/file/unarchive/" + daysToLive + "/" + downloadLimit + "/", 'PUT');
                $('#unarchiveConfirmModal').modal('hide')
            }, {once: true});

            $('#unarchiveConfirmModal').modal()

        })
    }

    const deleteButtons = document.getElementsByClassName('transfer-item-header-actions-deletelink')as HTMLCollection
    for (let item of deleteButtons) {

        item.addEventListener('click', (e) => {
            e.preventDefault()
            const transfer = (e.target as HTMLElement).closest('li')!;
            let selection = transfer.querySelectorAll('.list-item-checkbox:checked')
            if (selection.length === 0) {
                selection = transfer.querySelectorAll('.list-item-checkbox')
            }
            const files = [...selection].map(x => x.closest('li')!.dataset)
            deleteFilesPrompt(function (res) {
                if (res) {
                    processFiles(files, "/file/delete/", 'DELETE')
                }
            })
            // downloadMultipleFiles(db, files)

        })
    }

}

export class List {
    private itemDirection: number = -1
    private groupDirection: number = 1

    public groupKey: string = 'create_date'
    public itemKey: string = 'real_size'

    public data: any
    private readonly db: IDBDatabase;
    private mode: string;

    constructor(db: IDBDatabase) {
        this.db = db;
    }

    render(
        {
            data=undefined,
            groupKey=undefined,
            itemKey=undefined,
            tableMode=undefined
        } = {}) {

        if(data !== undefined) {
            this.data = data
        }
        if(tableMode !== undefined) {
            this.mode = tableMode
        }
        if(groupKey !== undefined) {
            this.groupKey = groupKey
            if(this.groupKey === groupKey) {
                this.groupDirection *= -1
            } else {
                this.groupKey = groupKey
            }
        }

        if(itemKey !== undefined) {
            if(this.itemKey === itemKey) {
                this.itemDirection *= -1
            } else {
                this.itemKey = itemKey
            }
        }
        const filelist = document.getElementById('filelist') as HTMLUListElement;
        filelist.innerText = '';   // note: save innerHtml
        if (this.data.length > 0) {
            generateTable(
                this.data,
                this.groupKey,
                this.groupDirection,
                this.itemKey,
                this.itemDirection,
                this.db,
                this.mode)
            // hide empty states

        } else {
            // hide empty states?
            for(let el of document.getElementsByClassName('empty-state')) {
                (el as HTMLElement).style.display = 'none'
            }
        }
        for(let el of document.getElementsByClassName('empty-state')) {
            if(data.length > 0) {
                (el as HTMLElement).style.display = 'none'
            } else {
                 if(el.id.indexOf(this.mode) >= 0) {
                     (el as HTMLElement).style.display = 'block'
                 }
            }
        }



    }

    filter(value: string) {
        value = value.toLowerCase()
        if (value === '') {
            //empty string, make all list-items blocked
            const listItems = document.getElementsByClassName('transfer-file-list-item') as HTMLCollection;
            for(let el of listItems) {
                el.classList.remove('d-none')
                el.classList.add('d-block')
            }
            // de initially collapsed
            const defaultCollapsed = document.getElementsByClassName('default-collapsed') as HTMLCollection;
            for(let el of defaultCollapsed) {
                el.classList.add('d-none')
                el.classList.remove('d-block')
            }
            //show opener expand collapse buttons
            const opener = document.getElementsByClassName('opener') as HTMLCollection;
            for (let el of opener) {
                el.classList.remove('d-none')
                el.classList.add('d-block')
            }
        } else {
            // show all list items (expand all)
            const listItems = document.getElementsByClassName('transfer-file-list-item') as HTMLCollection;
            for(let el of listItems) {
                el.classList.remove('d-none')
                el.classList.add('d-block')
            }
            // hide expand collapse buttons
            const opener = document.getElementsByClassName('opener') as HTMLCollection;
            for(let el of opener) {
                el.classList.add('d-none')
                el.classList.remove('d-block')
            }

            //now hide non matching files
            const fileNames = document.querySelectorAll('#filelist .uppy-Dashboard-Item-name');
            for(let el of fileNames) {
                const htmlliElement = el.closest('li')!;
                const t = el.closest('.transfer-item')!
                const fileNameMatches = (el as HTMLElement)!.innerText.toLowerCase().indexOf(value) >= 0;
                const prefixMatches = (t as HTMLElement)!.dataset['prefix']!.toLowerCase().indexOf(value) >= 0;
                const transferName = t.querySelector('.transfer-item-header-title-inner')!.textContent!;
                const transferNameMatches = transferName.toLowerCase().indexOf(value) >= 0;
                const found = fileNameMatches ||
                              transferNameMatches ||
                              prefixMatches;
                              // (t as HTMLElement).dataset['prefix'].toLowerCase().indexOf(value) >= 0;
                if (found) {
                    htmlliElement.classList.add('d-block')
                    htmlliElement.classList.remove('d-none')
                } else {
                    htmlliElement.classList.remove('d-block')
                    htmlliElement.classList.add('d-none')
                }
            }
        }
        // hide /show transfers accordingly
        const transfers = document.getElementsByClassName('transfer-item')
        Array.from(transfers).forEach((transfer: HTMLElement) => {
            const force = transfer.querySelectorAll('.d-block').length === 0;
            transfer.classList.toggle('d-none', force)
        })
    }
}


export const setupNewTable = async (db: IDBDatabase) => {
    if(!document.getElementById('filelist')) {
        return
    }

    const list = new List(db)
    let tableMode = document.getElementById('table_mode') as HTMLInputElement;
    const search = document.getElementById('search-input') as HTMLInputElement;

    const searchParameters = new URLSearchParams(document.location.search);
    if(searchParameters.has('filter_prefix')) {
        //switch tab
        if(searchParameters.has('table_mode')) {
            if (searchParameters.get('table_mode') === 'outbox') {
                document.getElementById('files-uploaded')!.classList.add('active')
                document.getElementById('files-received')!.classList.remove('active')
            } else {
                document.getElementById('files-uploaded')!.classList.remove('active')
                document.getElementById('files-received')!.classList.add('active')
            }
            tableMode.value = searchParameters.get('table_mode')!
        }

        // note: see  abit further below for how to set prefix into search field
    }


    async function update() {

        const r = await mfetch("/files/list/" + tableMode.value + document.location.search)
        const data = await r.json();
        // const data = []
        await list.render({data: data, tableMode: tableMode.value})
        search.style.display = data.length > 0 ? 'block' : 'none'
        return data;
    }
    const data = await update()
    console.log(data.length)

    function setupTabs() {
        function switchTabs(e: MouseEvent) {
            if(e.target === outbox) {
                outbox.classList.add('active')
                inbox.classList.remove('active')
                drive.classList.remove('active')
            }
            if(e.target === inbox) {
                inbox.classList.add('active')
                outbox.classList.remove('active')
                drive.classList.remove('active')
            }
            if(e.target === drive) {
                drive.classList.add('active')
                inbox.classList.remove('active')
                outbox.classList.remove('active')
            }
        }
        let outbox = document.getElementById('files-uploaded')!;
        let inbox = document.getElementById('files-received')!;
        let drive = document.getElementById('files-archived')!;
        // let howtoArchive = document.getElementById('howto-archive');
        if(outbox) {
            outbox.addEventListener('click', function (e) {
                tableMode.value = 'outbox'
                switchTabs(e)
                update().then((data)=>{
                    setupTableFunctions(data);
                })
                // howtoArchive.style.display = 'none'
            })
        }
        if(inbox) {
            inbox.addEventListener('click', function (e) {
                tableMode.value = 'inbox'
                switchTabs(e)
                update().then((data)=>{
                    setupTableFunctions(data);
                })
                // howtoArchive.style.display = 'none'
            })
        }

        if(drive) {
            drive.addEventListener('click', function (e) {
                tableMode.value = 'drive'
                switchTabs(e)
                update().then((data)=>{
                    setupTableFunctions(data);
                })
                // howtoArchive.style.display = 'block'
            })
        }

    }

    setupTabs()



    // list.render({data: data})

    document.getElementById('sort-transfers-date')!.addEventListener('click', () => {
        list.render({groupKey: 'create_date'})
    })

    document.getElementById('sort-transfers-expiry')!.addEventListener('click', () => {
        list.render({groupKey: 'expiry'})

    })
    document.getElementById('sort-files-name')!.addEventListener('click', () => {
        list.render({itemKey: 'name'})
    })
    document.getElementById('sort-files-downloads')!.addEventListener('click', () => {
        list.render({itemKey: 'downloads'})
    })
    document.getElementById('sort-files-size')!.addEventListener('click', () => {
        list.render({itemKey: 'real_size'})
    })


    search.addEventListener('input', () => {
        list.filter(search.value)
    })

    window.addEventListener('arc:update-table', async function () {
        let tableMode = document.getElementById('table_mode') as HTMLInputElement;
        const r = await mfetch("/files/list/" + tableMode.value + document.location.search) // todo remove the search here, we should only filter on the frontend

        if (r.status === 200) {
            const data = await r.json();
            list.render({data: data})
            setupTableFunctions(data)
            updateFileCounters()
        } else {
            if(document.location.href.indexOf('/external_downlad')) {
                document.location.href.replace('/external_download', '/expired')  // should take care of language
            } else {
                list.render({data: []}) // empty table
            }
        }
    }, false);

    function setupDecryptFilenameButtons(data: FileData[]) {

        let oldElement = document.getElementById('decrypt-all-button')!;
        let newElement = oldElement.cloneNode(true) as HTMLElement;
        oldElement.parentNode!.replaceChild(newElement, oldElement);

        if (newElement) {
            const decryptAll = (event: any) => {
                event.preventDefault();
                mainDecryptAllFilenames(db, event, data).then(() => {});
            };
            newElement.addEventListener('click', decryptAll);
            if (db) {
                mainDecryptAllFilenames(db, undefined, data).then(() => {});
            } else {
                newElement.style.display = 'inline-block';

            }
        }
        if (!db) {
            const filelist = document.getElementById('filelist')!
            filelist.addEventListener('click', (event) => {
                let target = event.target as HTMLElement

                if (target.tagName === 'CODE') {  // inner HTML could be clicked and thus the source
                    target = target.parentElement!
                }

                if (target.classList.contains('decrypt-button')) {
                    const row = target.closest('li')!.dataset
                    mainDecryptFilename(db, row)
                }
            })
        }

    }

    function setupDecryptMessage() {

        const filelist = document.getElementById('filelist')!
        filelist.addEventListener('click', (event) => {
            // event.preventDefault()
            let target = event.target as HTMLElement

            if (target.classList.contains('message-button')) {
                const row = target.closest('li')!.dataset
                decryptMessage(db, row)
            }
        })

        const elem = filelist.querySelector('.transfer-item') as HTMLElement;
        if(elem) {
            showExternalDownloadMessage(elem.dataset.encrypted_message)
        }

    }

    function setupDownloadButtons() {
        const isPlugin = document.body.classList.contains('plugin')
        if (isPlugin) {
            return
        }
        const filelist = document.getElementById('filelist')!
        filelist.addEventListener('click', (event) => {
            let target = event.target as HTMLElement
            target.setAttribute("disabled", "true")
            let timer = setTimeout(() => {target.removeAttribute("disabled")}, 500)

            if(target.classList.contains('uppy-Dashboard-Item-previewInnerWrap')) {
                target = target.querySelector('.uppy-Dashboard-Item-previewIcon')
            }

            if (target.classList.contains('uppy-Dashboard-Item-previewIcon')) {  //target.classList.toString().indexOf('uppy-Dashboard-Item-preview')

                event.preventDefault()
                event.stopPropagation()
                // if(target.closest('li').querySelector('.bottom-progress-bar')) {
                //     return
                // }
                const row = target.closest('li')!.dataset

                let isUnverified = row.verified === 'false';
                if (isUnverified) {
                    function callback(result: any) {
                        if (result) {
                            execute()
                        }
                    }

                    if (freeTier()) {
                        unverifiedDownloadPrompt(callback)
                    } else {
                        showFreeTierDepletedPrompt()
                    }

                } else {
                    execute()
                }

                function execute() {
                    if (row.password_hash === 'None') {
                        if (freeTier()) {
                            mainDownload(db, row).then(function () {});
                        } else {
                            showFreeTierDepletedPrompt()
                        }
                    } else {
                        function callback(passPhrase: string) {
                            if (passPhrase) {

                                mainDownload(db, row, passPhrase).then(function () {
                                })
                            }
                        }

                        if (freeTier()) {
                            pinPrompt(callback)
                        } else {
                            showFreeTierDepletedPrompt()
                        }
                    }
                }
            }
        })
    }

    function setupTableFunctions(data) {
        // setupDownloadButtons();
        // setupDecryptMessage()
        setupDecryptFilenameButtons(data)

        // list.filter(search.value)
        search.value = ''

    }

    setupTableFunctions(data)


    if(searchParameters.has('filter_prefix')) {
        //switch tab

        search.value = searchParameters.get('filter_prefix')
        tableMode.value = searchParameters.get('table_mode')
        search.dispatchEvent(new Event('input'))

    }

    setupDownloadButtons();
    setupDecryptMessage()


    handleTransferRenaming(db)
}




